<script lang="ts">
  import type { WithElementRef } from 'bits-ui';
  import type { HTMLAttributes } from 'svelte/elements';
  import { cn } from '$lib/utils';

  let {
    ref = $bindable(null),
    class: className,
    children,
    ...restProps
  }: WithElementRef<HTMLAttributes<HTMLTableCellElement>> = $props();
</script>

<th
  bind:this={ref}
  class={cn(
    'text-eyebrow text-gold/80 h-11 px-3 text-left align-middle [&:has([role=checkbox])]:pr-0',
    className,
  )}
  {...restProps}
>
  {@render children?.()}
</th>
